import React, { memo } from 'react';
import { string, PropTypes } from 'prop-types';

import { PROVIDER_ID, tecDocUrl } from 'utils/constantsHelper';

export const getImageTechDocUrl = (id) => {
  return tecDocUrl + 'documents/' + PROVIDER_ID + '/' + id;
};

export const ImageTechDoc = memo(({ id, alt, ...restprops }) => {
  return <img src={getImageTechDocUrl(id)} alt={alt} {...restprops} />;
});

ImageTechDoc.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: string,
  alt: string,
};

ImageTechDoc.defaultProps = {
  className: '',
  alt: '',
};



// WEBPACK FOOTER //
// ./src/components/ImageTechDoc/ImageTechDoc.js